export default __webpack_public_path__ + "static/logo-small-e22ffc8937584e064efa7518666494cc.svg";